//Get Reducer Call--->
export const getEmployeeRequest = (page: number, size: number, search: string) => ({
    type: 'GET_EMPLOYEE_REQUEST',
    payload: { page, size, search },
});

export const getEmployeeSuccess = (data: any) => ({
    type: 'GET_EMPLOYEE_SUCCESS',
    payload: { data },
});

export const getEmployeeFailure = (data: string) => ({
    type: 'GET_EMPLOYEE_FAILURE',
    payload: { data },
});

export const resetGetEmployee = () => ({
    type: 'RESET_GET_EMPLOYEE',
});

export const getUserRightsRequest = (id: string) => ({
    type: 'GET_USER_RIGHTS_REQUEST',
    payload: { id },
});

export const getUserRightsSuccess = (data: any) => ({
    type: 'GET_USER_RIGHTS_SUCCESS',
    payload: { data },
});

export const getUserRightsFailure = (data: string) => ({
    type: 'GET_USER_RIGHTS_FAILURE',
    payload: { data },
});

export const resetGetUserRights = () => ({
    type: 'RESET_GET_USER_RIGHTS',
});

//Create Reducer Call--->
export const createEmployeeRequest = (data: any) => ({
    type: 'CREATE_EMPLOYEE_REQUEST',
    payload: data,
});

export const createEmployeeSuccess = (data: any) => ({
    type: 'CREATE_EMPLOYEE_SUCCESS',
    payload: { data },
});

export const createEmployeeFailure = (data: string) => ({
    type: 'CREATE_EMPLOYEE_FAILURE',
    payload: { data },
});

export const resetCreateEmployee = () => ({
    type: 'RESET_CREATE_EMPLOYEE',
});

// User Rights
export const createUserRightsRequest = (data: any) => ({
    type: 'CREATE_USER_RIGHTS_REQUEST',
    payload: data,
});

export const createUserRightsSuccess = (data: any) => ({
    type: 'CREATE_USER_RIGHTS_SUCCESS',
    payload: { data },
});

export const createUserRightsFailure = (data: string) => ({
    type: 'CREATE_USER_RIGHTS_FAILURE',
    payload: { data },
});

export const resetCreateUserRights = () => ({
    type: 'RESET_CREATE_USER_RIGHTS',
});

//Update Reducer Call--->
export const updateEmployeeRequest = (data: any, id: string) => ({
    type: 'UPDATE_EMPLOYEE_REQUEST',
    payload: { data, id },
});

export const updateEmployeeCredentialsRequest = (data: any, id: string) => ({
    type: 'UPDATE_EMPLOYEE_CREDENTIALS_REQUEST',
    payload: { data, id },
});

export const updateEmployeeStatusRequest = (data: any, id: string) => ({
    type: 'UPDATE_EMPLOYEE_STATUS_REQUEST',
    payload: { data, id },
});

export const updateEmployeeSuccess = (data: any) => ({
    type: 'UPDATE_EMPLOYEE_SUCCESS',
    payload: { data },
});

export const updateEmployeeFailure = (data: string) => ({
    type: 'UPDATE_EMPLOYEE_FAILURE',
    payload: { data },
});

export const resetUpdateEmployee = () => ({
    type: 'RESET_UPDATE_EMPLOYEE',
});
//Delete Reducer Call--->
export const deleteEmployeeRequest = (id: string) => ({
    type: 'DELETE_EMPLOYEE_REQUEST',
    payload: { id },
});

export const deleteEmployeeSuccess = (data: any) => ({
    type: 'DELETE_EMPLOYEE_SUCCESS',
    payload: { data },
});

export const deleteEmployeeFailure = (data: string) => ({
    type: 'DELETE_EMPLOYEE_FAILURE',
    payload: { data },
});

export const resetDeleteEmployee = () => ({
    type: 'RESET_DELETE_EMPLOYEE',
});
